// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponEmptyBlock_root__2q6tq","text":"CouponEmptyBlock_text__Ij2_V"};